module.exports = __webpack_public_path__ + "media/components/home/masthead/img/space_1680x400@2x-92f74cd05131de1d8e7d84ab76033517.jpg";